module.exports = __webpack_public_path__ + "static/media/iPhoneX-Discover_AskHai.4b004ada.png";